import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { FieldType, FormlyModule } from "@ngx-formly/core";
import { omit } from "lodash";
import { Message } from "primeng/message";
import { NewUiCheckboxComponent } from "../../shared/form/checkbox/new-ui-checkbox.component";
import { NewUiFormElementMapModule } from "../../shared/from-element-map/new-ui-form-element-map.module";
import { TestIdDirective } from "../../shared/test-id/test-id.directive";

@Component({
  selector: "new-ui-formly-checkbox",
  templateUrl: "./new-ui-formly-checkbox.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    NewUiFormElementMapModule,
    TestIdDirective,
    FormlyModule,
    Message,
    NewUiCheckboxComponent,
  ],
})
export class NewUiFormlyCheckboxComponent extends FieldType {
  override defaultOptions = {
    props: {
      hideLabel: true,
    },
  };

  // otherwise the `id` attribute is also applied to the `p-checkbox`
  // which is wrong as the `id` attribute is unique per HTML page
  readonly fieldWithoutId = omit(this.field, "id");
}
